import React, { useState } from 'react';
import toast from 'react-hot-toast';
import logo from '../assets/logo.png';

function Login({ onLogin }) {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('password', password);
      if (!isLogin) {
        formData.append('name', name);
        formData.append('invite_code', inviteCode);
      }

      const endpoint = isLogin ? '/api/auth/login' : '/api/auth/register';
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}${endpoint}`, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        // Store JWT token in localStorage
        localStorage.setItem('token', data.token);
        
        toast.success(isLogin ? 'Welcome back!' : 'Account created!');
        onLogin(data.user);
      } else {
        toast.error(data.detail || 'Authentication failed');
      }
    } catch (error) {
      toast.error('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', padding: '3rem 0' }}>
      <div style={{ maxWidth: '400px', width: '90%', margin: '0 auto' }}>
        <div className="card" style={{ overflow: 'hidden', padding: 0, marginBottom: 0 }}>
          {/* Blue Header */}
          <div
            style={{
              background: 'var(--primary)',
              padding: '2rem 1.5rem',
              textAlign: 'center',
              color: 'white'
            }}
          >
            <h5 style={{ color: 'white', fontSize: '1.25rem', fontWeight: 500, marginBottom: '0.5rem' }}>
              {isLogin ? 'Welcome Back!' : 'Create Account'}
            </h5>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.875rem', margin: 0 }}>
              {isLogin ? 'Sign in to continue to Spark QR.' : 'Sign up to get started with Spark QR.'}
            </p>
            <div style={{ marginTop: '1rem' }}>
              <img src={logo} alt="Spark QR by BizHub" style={{ height: '50px' }} />
            </div>
          </div>

          {/* Form Body */}
          <div style={{ padding: '2rem 1.5rem' }}>
            <form onSubmit={handleSubmit}>
              {!isLogin && (
                <div style={{ marginBottom: '1rem' }}>
                  <label className="label">Name</label>
                  <input
                    type="text"
                    className="input"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter your name"
                    required={!isLogin}
                    data-testid="name-input"
                  />
                </div>
              )}

              {!isLogin && (
                <div style={{ marginBottom: '1rem' }}>
                  <label className="label">Invite Code *</label>
                  <input
                    type="text"
                    className="input"
                    value={inviteCode}
                    onChange={(e) => setInviteCode(e.target.value)}
                    placeholder="Enter your invite code"
                    required={!isLogin}
                    data-testid="invite-code-input"
                  />
                  <p style={{ fontSize: '0.75rem', color: 'var(--gray-600)', marginTop: '0.5rem' }}>
                    Don't have an invite code? Contact your administrator.
                  </p>
                </div>
              )}

              <div style={{ marginBottom: '1rem' }}>
                <label className="label">Email</label>
                <input
                  type="email"
                  className="input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter email"
                  required
                  data-testid="email-input"
                />
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label className="label">Password</label>
                <input
                  type="password"
                  className="input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  required
                  data-testid="password-input"
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary"
                style={{ width: '100%', marginBottom: '1rem' }}
                disabled={loading}
                data-testid="submit-button"
              >
                {loading ? (
                  <>
                    <div className="spinner" style={{ width: '16px', height: '16px', borderWidth: '2px' }}></div>
                    Please wait...
                  </>
                ) : (
                  isLogin ? 'Sign In' : 'Sign Up'
                )}
              </button>

              <div style={{ textAlign: 'center', fontSize: '0.875rem' }}>
                <span style={{ color: 'var(--gray-600)' }}>
                  {isLogin ? "Don't have an account? " : 'Already have an account? '}
                </span>
                <button
                  type="button"
                  onClick={() => setIsLogin(!isLogin)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--primary)',
                    cursor: 'pointer',
                    fontWeight: 500,
                    textDecoration: 'underline'
                  }}
                  data-testid="toggle-auth-mode"
                >
                  {isLogin ? 'Sign Up' : 'Sign In'}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Footer */}
        <div style={{ textAlign: 'center', marginTop: '2rem', color: 'var(--gray-600)', fontSize: '0.875rem' }}>
          <p>© {new Date().getFullYear()} Spark QR. A product of BizHub.</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
